<template>
  <div class="mktops-maincontent-create maincontent-create-1">
    <div class="mktops-mainheader-text md-layout-item md-size-100">
      <label class="tab-title create"> create a promotion </label>
    </div>
    <div class="md-gutter mktops-stepper">
      <md-card class="main-content">
        <div class="header-step">
          <md-avatar class="md-avatar-icon step-content-num">1</md-avatar>
          <span class="card-title">Basic Info </span>
        </div>
        <div class="data-input-step md-layout">
          <div class="md-layout">
            <div class="md-layout-item">
              <!-- <div class="md-layout-item md-size-50"> -->
              <md-card-content>
                <div class="content-step-data">
                  <div class="title-medium">Select a Promotion Strategy</div>
                  <div style="display: flex;">
                    <div
                      class="
                        selected-promotion-strategy
                        md-layout-item md-large-size-40 md-medium-size-40 md-small-size-40
                      "
                    >
                      <multiselect
                        :class="pmStrategyError === true ? 'next-error' : ''"
                        v-model="selectedPmStrategy"
                        id="number"
                        label="title"
                        track-by="number"
                        placeholder="Promotion Strategy"
                        :open-direction="'bottom'"
                        :options="optionsPmStrategy"
                        :searchable="true"
                        :max-height="180"
                        :show-no-results="false"
                        :select-label="''"
                        :deselect-label="''"
                        :selected-label="''"
                        :hide-selected="true"
                        @select="setDataTitle"
                        >
                        <!-- :custom-label="customLabelPmStrategy" -->
                        <template slot="singleLabel" slot-scope="{ option }">
                          <div>
                            <div
                              class="-label"
                              style="font-family: kanit; padding-top: 3px"
                            >
                              {{ option.title }}
                            </div>
                            <div
                              class="-delete"
                              style="padding-top: 2px; margin-right: 8px"
                              @mousedown.prevent.stop="clearAll(option.number)"
                            >
                              <i class="material-icons">close</i>
                            </div>
                          </div>
                        </template>
                      </multiselect>
                      <span v-show="pmStrategyError === true" style="color: #ff1744; font-size: 12px;">Please select Promotion Strategy</span>
                    </div>
                    <div>
                      <i class="md-icon material-icons -list_alt"
                        style="
                          color: #b3b3b3;
                          cursor: pointer;
                          font-size: 28px !important;
                          margin-top: 20px;
                          margin-left: 15px;
                        "
                        @mouseover="handleMouseOver"
                        @mouseout="handleMouseOut"
                      >
                          info
                      </i>
                    </div>
                    <!-- <div class="floating-data-title"> -->
                    <div class="floating-data-title" v-show="showFloatingData &&
                      (descriptionPmStrategy !== '' || benefitsPmStrategy !== '')">
                      <div style="font-weight: bold; font-size: 15px;">Description from Bard :</div>
                      <div style="margin-bottom: 15px;">{{ descriptionPmStrategy }}</div>
                      <div style="font-weight: bold; font-size: 15px;">Benefits from Bard :</div>
                      <div>{{ benefitsPmStrategy }}</div>
                    </div>
                  </div>

                  <div class="md-layout" style="width: 626px">
                    <div class="md-size-50" style="width: 330px">
                      <md-field :class="messageClass" class="pm-code">
                        <span style="display: none">{{ promotion_id }}</span>
                        <span style="display: none">{{
                          promotion_auto_code
                        }}</span>
                        <label>Promotion Code</label>
                        <span class="md-error">{{ spanPromotion }}</span>
                        <md-input
                          class="kanitfont"
                          autocomplete="off"
                          ref="promotion_code"
                          :disabled="disableCode"
                          v-model="promotion_code"
                          @keyup.native="alertNext"
                          @keypress.native="checkChar"
                          @paste="onPaste"
                        ></md-input>
                      </md-field>
                    </div>
                    <div
                      v-show="!disableCheckbox"
                      class="md-size-50"
                      style="font-weight: bold; font-family: kanit !important"
                    >
                      <md-checkbox
                        style="
                          font-family: kanit !important;
                          margin: 30px 0 0 10px;
                        "
                        v-model="auto_code"
                        :disabled="disableCheckbox"
                        >Generate Code</md-checkbox
                      >
                    </div>
                    <div
                      class="md-size-50"
                      style="font-weight: bold; font-family: kanit !important"
                    >
                      <md-checkbox
                        style="
                          font-family: kanit !important;
                          margin: 30px 0 0 10px;
                        "
                        v-model="is_fasttrack"
                        >Fast Track</md-checkbox
                      >
                    </div>
                  </div>
                  <md-field class="space-md-field" style="margin-top: 12px">
                    <label>Promotion Title</label>
                    <md-input
                      class="kanitfont"
                      autocomplete="off"
                      ref="promotion_title"
                      :disabled="promotion_active"
                      v-model="promotion_title"
                    ></md-input>
                  </md-field>
                  <label
                    style="
                      color: rgba(0, 0, 0, 0.38);
                      font-size: 16px;
                      padding-top: 16px;
                      display: inline-block;
                    "
                    >Promotion Detail</label
                  >
                  <md-field class="space-md-field" style="padding-top: 1px">
                    <!--<label>Promotion Detail</label>-->
                    <!--<md-input class="kanitfont" autocomplete="off" ref="promotion_detail" :disabled="(promotion_active)" v-model="promotion_detail"></md-input>-->
                    <md-textarea
                      class="kanitfont"
                      autocomplete="off"
                      ref="promotion_detail"
                      :disabled="promotion_active"
                      v-model="promotion_detail"
                    ></md-textarea>
                  </md-field>
                  <div class="md-layout" style="width: 626px">
                    <div
                      class="md-size-50"
                      style="width: 250px"
                      id="divstartdate"
                      ref="divstartdate"
                    >
                      <md-field
                        v-if="promotion_active"
                        class="space-md-field"
                        style="margin-bottom: 22px"
                      >
                        <i class="md-icon material-icons" style="color: #757575"
                          >calendar_today</i
                        >
                        <label>Start Date</label>
                        <md-input
                          autocomplete="off"
                          ref="startdate"
                          disabled
                          v-model="startdate"
                        ></md-input>
                      </md-field>
                      <md-datepicker
                        autocomplete="off"
                        v-else
                        ref="startdate"
                        class="start"
                        v-model="startdate"
                        :md-disabled-dates="disabledDates"
                        :md-immediately="true"
                      >
                        <label>Start Date</label>
                      </md-datepicker>
                    </div>
                    <!-- style="pointer-events: none;width: 250px;" -->
                    <div
                      class="md-size-50"
                      v-bind:style="{
                        pointerEvents: enddatesStyl,
                        width: '250px',
                      }"
                      id="divenddate"
                      ref="divenddate"
                    >
                      <md-field
                        v-if="promotion_active"
                        class="space-md-field"
                        style="margin-bottom: 22px"
                      >
                        <i class="md-icon material-icons" style="color: #757575"
                          >calendar_today</i
                        >
                        <label>End Date</label>
                        <md-input
                          autocomplete="off"
                          ref="enddate"
                          disabled
                          v-model="enddate"
                        ></md-input>
                      </md-field>
                      <md-datepicker
                        autocomplete="off"
                        v-else
                        ref="enddate"
                        class="end"
                        v-model="enddate"
                        :md-disabled-dates="disabledDates2"
                        :md-immediately="true"
                      >
                        <label>End date</label>
                      </md-datepicker>
                    </div>
                  </div>

                  <div
                    style="
                      width: fit-content;
                      display: flex;
                      margin-bottom: 20px;
                      cursor: pointer;
                    "
                    @click="addPromotionRepeat()"
                  >
                    <div style="margin-top: 3px">Promotion Set</div>
                    <md-checkbox
                      style="
                        font-family: kanit !important;
                        margin: 5px 0 0 10px;
                      "
                      v-model="checkRepeat"
                      @change="addPromotionRepeat()"
                    ></md-checkbox>
                  </div>
                  <!-- <md-card v-show="($store.getters['pmcreate/promotionRepeat'].length > 0)" class="box-promotion-repeat"> -->
                  <md-card
                    v-show="promotionRepeat && promotionRepeat.length > 0"
                    class="box-promotion-repeat"
                  >
                    <div
                      :class="'row-bg-gray'"
                      v-for="(items, idx) in promotionRepeat"
                      :key="items.keyId"
                      style="display: flex; padding: 5px 10px"
                    >
                      <!-- <div :class="'row-bg-gray'" v-for="(items, idx) in $store.getters['pmcreate/promotionRepeat']" :key="items.keyId" style="display: flex; padding: 5px 10px;"> -->
                      <div
                        style="width: 18%"
                        class="nowrap-title"
                        :title="items.promotion_code"
                      >
                        {{ items.promotion_code }}
                      </div>
                      <div
                        style="width: 62%"
                        class="nowrap-title"
                        :title="items.promotion_title"
                      >
                        {{ items.promotion_title }}
                      </div>
                      <div style="width: 15%; color: #1c64a0">
                        {{
                          items.condition == 0 ? "ต้องมี" : "มีหรือไม่มีก็ได้"
                        }}
                      </div>
                      <div style="width: 5%; text-align: right">
                        <span
                          class="tab-chip -delete"
                          @click="deleteFilter(items, idx)"
                        >
                          <i class="material-icons">close</i>
                        </span>
                      </div>
                    </div>
                  </md-card>

                  <div class="md-layout target" style="display: none">
                    <div class="div_target">
                      <label
                        :class="
                          promotion_active ? 'target -disabled' : 'target'
                        "
                        >Target by
                      </label>
                    </div>
                    <div>
                      <md-radio
                        :disabled="promotion_active"
                        v-model="target_type"
                        value="none"
                        ><span :class="promotion_active ? '-disabled' : ''"
                          >None</span
                        ></md-radio
                      >
                    </div>
                    <div>
                      <md-radio
                        :disabled="promotion_active"
                        v-model="target_type"
                        value="Set"
                        ><span :class="promotion_active ? '-disabled' : ''"
                          >By Set</span
                        >
                        <md-field>
                          <label>Value</label>
                          <md-input
                            autocomplete="off"
                            :disabled="promotion_active"
                            ref="set_value"
                            v-model="set_value"
                            @keypress="validate($event)"
                          ></md-input>
                        </md-field>
                      </md-radio>
                    </div>
                    <div>
                      <md-radio
                        :disabled="promotion_active"
                        v-model="target_type"
                        value="Sales Valus"
                        ><span :class="promotion_active ? '-disabled' : ''"
                          >By Sales Valus</span
                        >
                        <md-field>
                          <label>Value</label>
                          <md-input
                            autocomplete="off"
                            :disabled="promotion_active"
                            ref="sales_value"
                            v-model="sales_value"
                            @keypress="validate($event)"
                          ></md-input>
                        </md-field>
                      </md-radio>
                    </div>
                  </div>
                  <md-switch
                    v-if="checkActive()"
                    v-model="promotion_active"
                    :disabled="vInactive"
                    >Promotion Active</md-switch
                  >
                  <md-switch v-else v-model="promotion_active" disabled
                    >Promotion Active</md-switch
                  >
                </div>
              </md-card-content>
            </div>
          </div>
        </div>
        <md-card-actions class="mktops-action-button">
          <md-button
            v-if="!promotion_active"
            class="mktops-action-button next"
            @click="nextStep('step-2')"
            >next</md-button
          >
        </md-card-actions>
      </md-card>
      <stepper></stepper>
    </div>

    <md-snackbar
      :md-position="position"
      :md-duration="isInfinity ? Infinity : duration"
      :md-active.sync="showSnackbar"
      md-persistent
    >
      <span>{{ dContent }}</span>
      <md-button class="md-primary" @click="showSnackbar = false">OK</md-button>
    </md-snackbar>

    <md-dialog-confirm
      :md-active.sync="alert"
      md-title="Alert!"
      md-content="Promotion Code can not have special characters or tap."
      md-cancel-text=""
      md-confirm-text="OK"
      @md-confirm="onAlertOK"
    />

    <md-dialog
      :md-active.sync="showDialogRepeat"
      class="dialog-promotion-repeat"
      :md-click-outside-to-close="false"
    >
      <md-dialog-title>Promotion Repeat</md-dialog-title>

      <div class="layout-dialog">
        <div
          class="md-layout-item md-large-size-100 md-medium-size-100 mkt-ops -main-font"
          style="display: flex"
        >
          <md-field class="md-search-box">
            <i class="md-icon material-icons">search</i>
            <md-input
              type="text"
              placeholder="Code or Promotion Title"
              v-model="vSearchPromotion"
              @input="searchPromotion()"
            ></md-input>
          </md-field>
          <div style="width: 60%; text-align: right; margin-top: 15px">
            <i
              title="Delete"
              class="md-icon material-icons"
              style="color: #b3b3b3; cursor: pointer"
              @click="deletePromotion()"
              >delete_sweep</i
            >
          </div>
        </div>
      </div>

      <div class="layout-dialog" style="display: flex">
        <div
          class="md-layout-item md-large-size-50 md-medium-size-50 mkt-ops -main-font"
        >
          <div id="table-promotion-repeat">
            <div id="divHeadList">
              <div style="width: 8%">
                <!-- <label class="-mkt-checkbox-container">
                                <input type="checkbox" @click="selectAllProductFilter" v-model="checkedProductFilterAll">
                                <span class="-mkt-checkbox"></span>
                            </label> -->
              </div>
              <div style="width: 30%">Code</div>
              <div style="width: 62%">Description</div>
            </div>
            <div id="divBodyList">
              <div
                v-show="tbListPromotion == null || tbListPromotion.length == 0"
                :class="'row-bg-gray'"
                style="display: block; text-align: center"
              >
                No data in table.
              </div>
              <!-- <div v-show="(checkedPromotion.indexOf(item.promotion_code) == -1)" :class="'row-bg-gray'" v-for="(item, rIndex) in tbListPromotion" :key="rIndex"> -->
              <div
                :class="'row-bg-gray'"
                v-for="(item, rIndex) in tbListPromotion"
                :key="rIndex"
                :style="
                  item.promotion_code == promotion_code ? 'display: none;' : ''
                "
              >
                <div style="width: 8%">
                  <label class="-mkt-checkbox-container">
                    <input
                      type="checkbox"
                      v-model="checkedPromotion"
                      :id="item.promotion_code"
                      :value="item.promotion_code"
                      @click="selectPromotion(item)"
                    />
                    <span class="-mkt-checkbox"></span>
                  </label>
                </div>
                <div style="width: 30%" class="nowrap-title -font-kanit">
                  <span :title="item.promotion_code">{{
                    item.promotion_code
                  }}</span>
                </div>
                <div style="width: 62%" class="nowrap-title -font-kanit">
                  <span :title="item.promotion_title">{{
                    item.promotion_title
                  }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="md-layout-item md-large-size-50 md-medium-size-50 mkt-ops -main-font"
        >
          <div id="table-promotion-repeat">
            <div id="divHeadList">
              <div style="width: 8%">
                <!-- <label class="-mkt-checkbox-container">
                                <input type="checkbox" @click="selectAllProductFilter" v-model="checkedProductFilterAll">
                                <span class="-mkt-checkbox"></span>
                            </label> -->
              </div>
              <div style="width: 52%">Code</div>
              <div style="width: 40%"></div>
            </div>
            <div id="divBodyList">
              <div
                v-show="
                  tbSelectedPromotion == null || tbSelectedPromotion.length == 0
                "
                :class="'row-bg-gray'"
                style="display: block; text-align: center"
              >
                No data in table.
              </div>
              <!-- <div v-show="(checkedPromotionSelected.indexOf(item.promotion_code) == -1)" :class="'row-bg-gray'" v-for="(item, rIndex) in tbSelectedPromotion" :key="rIndex"> -->
              <div
                :class="'row-bg-gray'"
                v-for="(item, rIndex) in tbSelectedPromotion"
                :key="rIndex"
              >
                <div style="width: 8%">
                  <label class="-mkt-checkbox-container">
                    <input
                      type="checkbox"
                      v-model="checkedPromotionSelected"
                      :id="item.promotion_code"
                      :value="item.promotion_code"
                      @click="selectPromotionSelected(item)"
                    />
                    <span class="-mkt-checkbox"></span>
                  </label>
                </div>
                <div style="width: 52%" class="nowrap-title -font-kanit">
                  <span :title="item.promotion_code">{{
                    item.promotion_code
                  }}</span>
                </div>
                <div style="width: 40%" class="mktops-subheader-filter">
                  <md-field class="box">
                    <md-select
                      v-model="tbSelectedPromotion[rIndex].condition"
                      id="select-price-unit"
                    >
                      <md-option
                        v-for="(itemSlc, index) in promoCondition"
                        :key="index"
                        :value="index"
                        >{{ itemSlc }}</md-option
                      >
                    </md-select>
                  </md-field>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <md-dialog-actions class="-action">
        <md-button class="md-primary -cancel" @click="onClickClose()"
          >CANCEL</md-button
        >
        <md-button
          :class="
            disableAddData && tbSelectedPromotion.length == 0
              ? 'md-primary -save -disabled'
              : 'md-primary -save'
          "
          :disabled="disableAddData"
          @click="onclickAddPromotion()"
          >CONFIRM</md-button
        >
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>

<script>
import moment from "moment-timezone";
import promotionService from "@/services/promotion";
import _ from "lodash";
import { constants } from "crypto";
export default {
  name: "step1",
  created() {
    this.getListPmStrategy();
  },
  data: () => ({
    disabledDates: (date) => {
      // return date.getTime() < Date.now()
      return date < moment().add(-1, "days");
    },
    disabledDates2: (date) => {
      // return date.getTime() < Date.now()
      return date < moment().add(-1, "days");
    },
    messageClass: "space-md-field",
    spanPromotion: "be more than equal 5 characters",
    enddatesStyl: "none",
    showSnackbar: false,
    position: "center",
    duration: 4000,
    isInfinity: false,
    dContent: "",
    vCheckActive: false,
    vInactive: false,
    disableCode: false,
    disableCheckbox: false,
    auto_code: false,
    // is_fasttrack: false,
    alert: false,
    // promotionRepeat: [],
    showDialogRepeat: false,
    tbListPromotion: [],
    tbSelectedPromotion: [],
    checkedPromotionSelected: [],
    checkedPromotion: [],
    disableAddData: true,
    slcCondition: [],
    promoCondition: ["ต้องมี", "มีหรือไม่มีก็ได้"],
    // tmpProductSelected: [],
    // tmpCheckedPromotion: [],
    // tmpCheckedPromotionSelected: [],
    vSearchPromotion: "",
    masterDataPromotion: [],
    selectedPmStrategy: [],
    optionsPmStrategy: [],
    // optionsPmStrategy: [
    //     {
    //         "username": "nattaphat",
    //         "firstname": "ณัฏฐภัทร์",
    //         "lastname": "สินปรุ"
    //     },
    //     {
    //         "username": "ratchakorn",
    //         "firstname": "รัชกร",
    //         "lastname": "สีมาวรพงศ์พันธุ์"
    //     },
    //     {
    //         "username": "chompunik_p",
    //         "firstname": "ชมพูนิกข์",
    //         "lastname": "ภูมิพิระรัถยา"
    //     },
    //     {
    //         "username": "benjamard",
    //         "firstname": "เบญจมาศ",
    //         "lastname": "ฟูทรัพย์นิรันดร์"
    //     },
    //     {
    //         "username": "pavinee_k",
    //         "firstname": "ปวิณี",
    //         "lastname": "คงคา"
    //     },
    //     {
    //         "username": "chayanin_p",
    //         "firstname": "ชญานิน",
    //         "lastname": "ปลั่งสุวรรณ"
    //     },
    //     {
    //         "username": "chutimon_b",
    //         "firstname": "ชุติมณฑน์",
    //         "lastname": "บุญธาราม"
    //     }
    // ],
    // titlePromotionStrategy: "",
    descriptionPmStrategy: "",
    benefitsPmStrategy: "",
    showFloatingData: false,
    pmStrategyError: false
  }),
  components: {
    /* eslint-disable */
    stepper: require("@/components/promotion/create/stepper").default,
    /* eslint-disable */
  },
  watch: {
    startdate(val) {
      if (val == null) {
        let r = this.$refs.startdate;
        r.$el.children[3].dispatchEvent(new Event("click"));
      }
    },
    enddate(val) {
      if (val == null) {
        let r = this.$refs.enddate;
        r.$el.children[3].dispatchEvent(new Event("click"));
      }
    },
    auto_code(isGenAuto) {
      if (isGenAuto) {
        this.promotion_code = "Generate Code";
        this.disableCode = true;
        this.$store.commit("pmcreate/update", {
          field: "auto_code",
          value: true,
        });
      } else {
        this.disableCode = false;
        this.promotion_code = "";
        this.$store.commit("pmcreate/update", {
          field: "auto_code",
          value: false,
        });
      }
    },
    is_fasttrack(isFastTrack) {
      if (isFastTrack) {
        this.$store.commit("pmcreate/update", {
          field: "is_fasttrack",
          value: true,
        });
      } else {
        this.$store.commit("pmcreate/update", {
          field: "is_fasttrack",
          value: false,
        });
      }
    },
  },
  computed: {
    promotion_id: function () {
      //-- START Promotion Strategy --//
      let promotionStrategy = this.$store.state["pmcreate"].value.promotion_type;
      this.selectedPmStrategy = this.optionsPmStrategy.find(option => option.number === parseInt(promotionStrategy));
      const pmStrategyIndex = this.optionsPmStrategy.findIndex(option => option.number === parseInt(promotionStrategy));
      // console.log("this.selectedPmStrategy ==>", this.selectedPmStrategy);
      if(pmStrategyIndex > -1) {
        this.descriptionPmStrategy = this.selectedPmStrategy.description;
        this.benefitsPmStrategy = this.selectedPmStrategy.benefits;
      }
      //-- END Promotion Strategy --//

      let id = this.$store.state["pmcreate"].value._id;
      this.disableCode = false;
      this.disableCheckbox = false;
      if (id !== undefined && id !== null && id.trim() !== "") {
        this.disableCode = true;
        this.disableCheckbox = true;
      }
      return this.$store.state["pmcreate"].value._id;
    },
    value: {
      get() {
        return this.$store.state["pmcreate"].value;
      },
    },
    promotion_type() {
      return this.$store.state["pmcreate"].value.promotion_type;
    },
    promotion_auto_code: {
      get() {
        let id = this.$store.state["pmcreate"].value._id;
        if (id === undefined || id === null || id.trim() === "") {
          if (this.$store.state["pmcreate"].value.auto_code === undefined) {
            this.auto_code = false;
          } else {
            this.auto_code = this.$store.state["pmcreate"].value.auto_code;
          }
        }
        return this.$store.state["pmcreate"].value.auto_code;
      },
      set(value) {},
    },
    promotion_code: {
      get() {
        return this.$store.state["pmcreate"].value.promotion_code;
      },
      set(value) {
        if (value != null && !this.alert) {
          if (value.length > 0) {
            value = value.trim();
            this.$store.dispatch("pmcreate/ck_promotion_code", {
              value,
            });
          }
        }

        this.$store.commit("pmcreate/update", {
          field: "promotion_code",
          value,
        });
      },
    },
    promotion_title: {
      get() {
        return this.$store.state["pmcreate"].value.promotion_title;
      },
      set(value) {
        this.$store.commit("pmcreate/update", {
          field: "promotion_title",
          value,
        });
      },
    },
    promotion_detail: {
      get() {
        return this.$store.state["pmcreate"].value.promotion_detail;
      },
      set(value) {
        this.$store.commit("pmcreate/update", {
          field: "promotion_detail",
          value,
        });
      },
    },
    startdate: {
      get() {
        return this.$store.state["pmcreate"].value.startdate;
      },
      set(value) {
        let inputElements = this.$refs.startdate.$el.children[1];
        inputElements.setAttribute("autocomplete", "off");

        this.enddatesStyl = "unset";
        if (this.$refs.startdate.$el.children[3]) {
          this.$refs.startdate.$el.children[3].addEventListener(
            "click",
            this.clearstartdate,
            false
          );
        }
        var myDate = new Date(value);
        // myDate.setDate(myDate.getDate() + 1);
        myDate.setDate(myDate.getDate());
        this.disabledDates2 = (date) => {
          const day = date.getDay();
          return date.getTime() < myDate;
        };

        this.$store.commit("pmcreate/update", {
          field: "startdate",
          value,
        });
      },
    },
    enddate: {
      get() {
        return this.$store.state["pmcreate"].value.enddate;
      },
      set(value) {
        let inputElements = this.$refs.enddate.$el.children[1];
        inputElements.setAttribute("autocomplete", "off");

        this.$store.commit("pmcreate/update", {
          field: "enddate",
          value,
        });
      },
    },
    target_type: {
      get() {
        return this.$store.state["pmcreate"].value.target_type;
      },
      set(value) {
        this.$store.commit("pmcreate/update", {
          field: "target_type",
          value,
        });
      },
    },
    set_value: {
      get() {
        return this.$store.state["pmcreate"].value.set_value;
      },
      set(value) {
        this.$store.commit("pmcreate/update", {
          field: "set_value",
          value,
        });
      },
    },
    sales_value: {
      get() {
        return this.$store.state["pmcreate"].value.sales_value;
      },
      set(value) {
        this.$store.commit("pmcreate/update", {
          field: "sales_value",
          value,
        });
      },
    },
    promotion_active: {
      get() {
        let val = false;
        this.$store.commit("pmcreate/update", {
          field: "promotion_active",
          val,
        });

        return this.$store.state["pmcreate"].value.promotion_active;
      },
      set(value) {
        // let val = value;
        // val = (this.vCheckActive) ? true : false;
        // this.vInactive = (val) ? true : false;
        // this.$store.commit("pmcreate/update", {
        //     field: "promotion_active",
        //     val
        // })
      },
    },
    // check_active: {
    //   get() {
    //     console.log("AAA ==>", this.$store.state["pmcreate"]);
    //     return this.$store.state["pmcreate"].statusAction;
    //   }
    // }
    checkRepeat: {
      get() {
        return this.$store.state["pmcreate"].value.repeat;
      },
      set(value) {
        this.$store.commit("pmcreate/setPromotionRepeat", value);
      },
    },
    promotionRepeat: {
      get() {
        return this.$store.state["pmcreate"].value.promotion_repeat;
      },
      set(value) {
        this.$store.commit("pmcreate/update", {
          field: "promotion_repeat",
          value: value,
        });
      },
    },
    tmpProductSelected: {
      get() {
        return this.$store.state["pmcreate"].tmp_product_selected;
      },
      set(value) {
        this.$store.commit("pmcreate/setTmpProductSelected", value);
      },
    },
    tmpCheckedPromotionSelected: {
      get() {
        return this.$store.state["pmcreate"].tmp_checked_promotion_selected;
      },
      set(value) {
        this.$store.commit("pmcreate/setTmpCheckedPromotionSelected", value);
      },
    },
    tmpCheckedPromotion: {
      get() {
        return this.$store.state["pmcreate"].tmp_checked_promotion;
      },
      set(value) {
        this.$store.commit("pmcreate/setTmpCheckedPromotion", value);
      },
    },
    is_fasttrack: {
      get() {
        return this.$store.state["pmcreate"].value.is_fasttrack;
      },
      set(value) {
        this.$store.commit("pmcreate/update", {
          field: "is_fasttrack",
          value: value,
        });
      },
    },
  },
  methods: {
    // customLabelPmStrategy({ firstname, lastname }) {
    //   return `${firstname} ${lastname}`;
    // },
    clearAll(id, type) {
      this.selectedPmStrategy = [];
      this.$store.commit("pmcreate/setPromotionType", "");

      this.descriptionPmStrategy = "";
      this.benefitsPmStrategy = "";
    },
    handleMouseOver() {
      this.showFloatingData = true;
    },
    handleMouseOut() {
      this.showFloatingData = false;
    },
    getListPmStrategy() {
      promotionService.getPmStrategy()
        .then((response) => {
          if (response) {
            // console.log("response ==>", response);
            this.optionsPmStrategy = response;
          }
        })
        .catch();
    },
    setDataTitle(selectedOption, id) {
      // console.log("selectedOption ==>", selectedOption);
      // this.titlePromotionStrategy = selectedOption.description;
      this.descriptionPmStrategy = selectedOption.description;
      this.benefitsPmStrategy = selectedOption.benefits;
      this.pmStrategyError = false;

      this.$store.commit("pmcreate/setPromotionType", selectedOption.number);
    },
    
    searchPromotion() {
      let keyword = this.vSearchPromotion.replace(
        /([.*+?^=!:${}()|\[\]\/\\])/g,
        "\\$1"
      );
      let re = new RegExp(keyword, "gi");
      let response = _.filter(this.masterDataPromotion, (item) => {
        if (item.promotion_code !== null && item.promotion_code.match(re)) {
          return true;
        }
        if (item.promotion_title !== null && item.promotion_title.match(re)) {
          return true;
        }
      });

      if (this.vSearchPromotion != "") {
        this.tbListPromotion = response;
      } else {
        this.tbListPromotion = this.masterDataPromotion;
      }
    },
    selectPromotion(promotion) {
      if (this.checkedPromotion.indexOf(promotion.promotion_code) == -1) {
        this.checkedPromotion.push(promotion.promotion_code);

        this.tbSelectedPromotion.push({
          promotion_code: promotion.promotion_code,
          promotion_title: promotion.promotion_title,
          condition: 0,
        });
      } else {
        this.checkedPromotion.splice(
          this.checkedPromotion.indexOf(promotion.promotion_code),
          1
        );

        let index = this.tbSelectedPromotion.findIndex(
          (item) => item.promotion_code === promotion.promotion_code
        );
        this.tbSelectedPromotion.splice(index, 1);
        // this.checkedPromotionSelected.splice(this.checkedPromotionSelected.indexOf(promotion.promotion_code), 1);
      }

      /* Table Right Selected*/
      /*
            if(this.checkedPromotionSelected.indexOf(promotion.promotion_code) == -1) {
                this.tbSelectedPromotion.push({
                    promotion_code: promotion.promotion_code,
                    promotion_title: promotion.promotion_title
                });
                this.checkedPromotionSelected.push(promotion.promotion_code);
            } else {
                let index = this.tbSelectedPromotion.findIndex(item => item.promotion_code === promotion.promotion_code);
                this.tbSelectedPromotion.splice(index, 1);

                this.checkedPromotionSelected.splice(this.checkedPromotionSelected.indexOf(promotion.promotion_code), 1);
            }
            */

      if (this.tbSelectedPromotion.length > 0) {
        this.disableAddData = false;
      }
    },
    selectPromotionSelected(promotion) {
      if (
        this.checkedPromotionSelected.indexOf(promotion.promotion_code) == -1
      ) {
        this.checkedPromotionSelected.push(promotion.promotion_code);
      } else {
        this.checkedPromotionSelected.splice(
          this.checkedPromotionSelected.indexOf(promotion.promotion_code),
          1
        );
      }
    },
    deletePromotion() {
      let self = this;
      this.checkedPromotionSelected.forEach(function (value, key) {
        let index = self.tbSelectedPromotion.findIndex(
          (item) => item.promotion_code === value
        );
        self.tbSelectedPromotion.splice(index, 1);

        self.checkedPromotion.splice(self.checkedPromotion.indexOf(value), 1);
      });

      if (this.tbSelectedPromotion.length > 0) {
        this.disableAddData = false;
      } else {
        this.disableAddData = true;
      }
    },
    onclickAddPromotion() {
      this.promotionRepeat = JSON.parse(
        JSON.stringify(this.tbSelectedPromotion)
      );
      // this.$store.commit("pmcreate/update", {
      //         field: "promotion_repeat",
      //         value: this.promotionRepeat
      //     });

      // this.tmpProductSelected = JSON.parse(JSON.stringify(this.promotionRepeat));
      this.tmpProductSelected = JSON.parse(
        JSON.stringify(this.$store.state["pmcreate"].value.promotion_repeat)
      );
      this.tmpCheckedPromotion = JSON.parse(
        JSON.stringify(this.checkedPromotion)
      );
      this.tmpCheckedPromotionSelected = JSON.parse(
        JSON.stringify(this.checkedPromotionSelected)
      );

      if (this.promotionRepeat && this.promotionRepeat.length > 0) {
        let checkConRepeat = 0;
        _.forEach(this.promotionRepeat, (repeat, i) => {
          if (this.promotionRepeat[i].condition == 0) {
            checkConRepeat++;
          }
        });
        this.$store.commit("pmcreate/setPromotionRepeat", true);
        this.$store.commit(
          "pmcreate/setSumPromotion",
          this.promotionRepeat.length
        );
        this.$store.commit(
          "pmcreate/setSumStartUp",
          checkConRepeat == 0 ? 1 : checkConRepeat
        );
      } else {
        this.$store.commit("pmcreate/setPromotionRepeat", false);
        this.$store.commit("pmcreate/setSumPromotion", 0);
        this.$store.commit("pmcreate/setSumStartUp", 0);
      }

      this.vSearchPromotion = "";
      this.showDialogRepeat = false;
    },
    onClickClose() {
      if (this.promotionRepeat && this.promotionRepeat.length > 0) {
        this.$store.commit("pmcreate/setPromotionRepeat", true);
      } else {
        this.$store.commit("pmcreate/setPromotionRepeat", false);
      }

      this.vSearchPromotion = "";
      this.showDialogRepeat = false;
    },
    addPromotionRepeat() {
      let self = this;
      this.tmpProductSelected = this.$store.state[
        "pmcreate"
      ].value.promotion_repeat;

      this.tmpCheckedPromotion = [];
      this.tmpCheckedPromotionSelected = [];
      this.tmpProductSelected.forEach(function (value, key) {
        self.tmpCheckedPromotion.push(value.promotion_code);
      });

      self.tbSelectedPromotion = JSON.parse(
        JSON.stringify(self.tmpProductSelected)
      );
      self.checkedPromotion = JSON.parse(
        JSON.stringify(self.tmpCheckedPromotion)
      );
      self.checkedPromotionSelected = JSON.parse(
        JSON.stringify(self.tmpCheckedPromotionSelected)
      );

      if (this.promotionRepeat.length == 0) {
        self.tbSelectedPromotion = [];
        self.checkedPromotion = [];
        self.checkedPromotionSelected = [];
      } else {
        this.disableAddData = false;
      }

      promotionService
        .getAllPromotionRepeat()
        .then((response) => {
          if (response) {
            self.tbListPromotion = response.data;
            self.masterDataPromotion = response.data;
            self.showDialogRepeat = true;
          }
        })
        .catch();
    },
    deleteFilter(items, index) {
      let tmpArr = [];
      for (let i = 0; i < this.promotionRepeat.length; i++) {
        if (i != index) {
          tmpArr.push(this.promotionRepeat[i]);
        } else {
          this.checkedPromotion.splice(index, 1);
          this.checkedPromotionSelected.splice(index, 1);

          this.tmpCheckedPromotion = this.checkedPromotion;
          this.tmpCheckedPromotionSelected = this.checkedPromotionSelected;
          this.tmpProductSelected = tmpArr;
        }
      }
      this.promotionRepeat = tmpArr;

      if (this.promotionRepeat.length == 0) {
        this.$store.commit("pmcreate/setPromotionRepeat", false);
      }

      // this.optionsPromotion.push(items);
      // this.optionsPromotion.sort((a, b) => (a.promotion_code > b.promotion_code) ? 1 : -1)
    },
    validate(evt, val) {
      var theEvent = evt || window.event;
      if (theEvent.type === "paste") {
        key = event.clipboardData.getData("text/plain");
      } else {
        var key = theEvent.keyCode || theEvent.which;
        key = String.fromCharCode(key);
      }

      if (evt.target.value != "") {
        let dot = evt.target.value.split(".").length - 1;
        if (dot > 0 && key == ".") {
          theEvent.returnValue = false;
          if (theEvent.preventDefault) theEvent.preventDefault();
        }
      }

      var regex = /[0-9]|\./;
      if (!regex.test(key)) {
        theEvent.returnValue = false;
        if (theEvent.preventDefault) theEvent.preventDefault();
      }
    },
    checkActive(status) {
      // this.vCheckActive = (this.value.type == 'Active') ? true : false;
      /* Change Process 15.05.2019 */
      this.vCheckActive = false;
      return this.vCheckActive;
    },
    clearstartdate() {
      this.enddatesStyl = "none";
      if (this.$refs.enddate.$el.children[3]) {
        this.$refs.enddate.$el.children[3].click();
      }
    },
    nextStep(step) {
      if (this.promotion_active) {
        this.dContent = "Your promotion has active.";
        this.showSnackbar = true;
        return false;
      }

      if(this.selectedPmStrategy === undefined || this.selectedPmStrategy === "") {
        this.pmStrategyError = true;
        return;
      }

      let ck_promotion = this.$store.state["pmcreate"].ck_promotion;
      if (
        this.promotion_code === "" ||
        this.promotion_code === null ||
        this.promotion_code.length < 5
      ) {
        this.spanPromotion = "be more than equal 5 characters";
        this.messageClass = "space-md-field md-invalid";
        this.$refs.promotion_code.$el.focus();
      } else if (
        this.$store.state["pmcreate"].value._id === undefined &&
        (this.promotion_code === "" ||
          this.promotion_code === null ||
          this.promotion_code.length > 30)
      ) {
        this.spanPromotion = "Promotion Code must be less than 30 characters";
        this.messageClass = "space-md-field md-invalid";
        this.$refs.promotion_code.$el.focus();
      } else if (
        this.promotion_code === "" ||
        this.promotion_code === null ||
        this.promotion_code.length < 5 ||
        ck_promotion
      ) {
        this.spanPromotion = "Promotion Code Duplicate";
        this.messageClass = "space-md-field md-invalid";
        this.$refs.promotion_code.$el.focus();
      } else if (this.promotion_title === "" || this.promotion_title === null) {
        this.messageClass = "space-md-field";
        this.$refs.promotion_title.$el.focus();
      } else if (
        this.$refs.startdate.$refs.input === undefined ||
        this.$refs.startdate.$refs.input.$el.value === ""
      ) {
        this.messageClass = "space-md-field";
        this.startdate = "";
        this.$refs.startdate.value = "";
        this.$refs.startdate.$refs.input.$el.focus();
        this.enddatesStyl = "none";
      } else if (
        this.$refs.enddate.$refs.input === undefined ||
        this.$refs.enddate.$refs.input.$el.value === ""
      ) {
        this.messageClass = "space-md-field";
        this.enddate = "";
        this.$refs.enddate.value = "";
        this.$refs.enddate.$refs.input.$el.focus();
      } else if (
        this.target_type === "Set" &&
        (this.set_value === "" || this.set_value === null)
      ) {
        this.messageClass = "space-md-field";
        this.$refs.set_value.$el.focus();
      } else if (
        this.target_type === "Sales Valus" &&
        (this.sales_value === "" || this.sales_value === null)
      ) {
        this.messageClass = "space-md-field";
        this.$refs.sales_value.$el.focus();
      } else {
        this.messageClass = "space-md-field";
        this.$store.commit("pmcreate/setStep", step);
      }

      // this.$store.commit("pmcreate/setStep", step)
    },
    // setPromotionType(type) {
    //   this.$store.commit("pmcreate/setPromotionType", type);
    // },
    alertNext() {
      if (this.promotion_code.length > 4) {
        this.messageClass = "space-md-field";
      } else {
        this.messageClass = "space-md-field md-invalid";
      }

      if (
        this.$store.state["pmcreate"].value._id === undefined &&
        (this.promotion_code === "" ||
          this.promotion_code === null ||
          this.promotion_code.length > 30)
      ) {
        this.spanPromotion = "Promotion Code must be less than 30 characters";
        this.messageClass = "space-md-field md-invalid";
        this.$refs.promotion_code.$el.focus();
      }
    },
    checkChar(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode === 9 ||
        (charCode > 31 && charCode < 45) ||
        (charCode > 45 && charCode < 48) ||
        (charCode > 57 && charCode < 65) ||
        (charCode > 90 && charCode < 95) ||
        (charCode > 95 && charCode < 97) ||
        (charCode > 122 && charCode < 127)
      ) {
        this.keepEvent = false;
        evt.preventDefault();
      } else {
        let self = this;
        setTimeout(function () {
          //   console.log("evt ==>", evt.target.value);
          if (
            self.$store.state["pmcreate"].value._id === undefined &&
            evt.target.value.length > 30
            // this.promotion_code.length > 30
          ) {
            evt.preventDefault();
          } else {
            self.keepEvent = true;
            return true;
          }
        }, 500);
      }
    },
    onPaste(evt) {
      let paste = (evt.clipboardData || window.clipboardData).getData("text");
      const specialChars = "<>@!#$%^&*()+[]{}?:;|'\"\\,./~`= \t";
      var checkForSpecialChar = function (string) {
        for (let i = 0; i < specialChars.length; i++) {
          if (string.indexOf(specialChars[i]) > -1) {
            return true;
          }
        }
        return false;
      };

      if (checkForSpecialChar(paste)) {
        this.alert = true;
      }
    },
    onAlertOK() {
      this.promotion_code = "";
    },
  },
};
</script>

<style>
#layout-default > div.mkt-main-content > div.mktops-create {
  background-color: #fff;
  padding: 18px 18px;
}

#layout-default
  > div.mkt-main-content
  > div.mktops-create
  > div
  > div.md-gutter.mktops-stepper
  > div.md-card.main-content.md-theme-default {
  margin-right: 20px;
}

#layout-default
  > div.mkt-main-content
  > div.mktops-create
  > div
  > div.mktops-mainheader-text.md-layout-item.md-size-100
  > label.create {
  color: #797979;
  font-size: 18px;
  font-family: "Lato";
  text-transform: uppercase;
}

#layout-default
  > div.mkt-main-content
  > div.mktops-create
  > div
  > div.md-gutter.mktops-stepper {
  height: calc(100vh - 80px);
}

#layout-default
  > div.mkt-main-content
  > div.mktops-create
  > div
  > div.md-gutter.mktops-stepper
  > div.md-card.main-content.md-theme-default
  > div.data-input-step.md-layout {
  height: calc(100vh - 190px);
}

#layout-default
  > div.mkt-main-content
  > div.mktops-create
  > div
  > div.md-gutter.mktops-stepper
  > div.md-card.main-content.md-theme-default
  > div.header-step
  > span {
  padding-top: 20px;
  font-size: 18px;
  font-weight: 500;
  font-family: "Roboto";
  padding-left: 13px;
}

#layout-default
  > div.mkt-main-content
  > div.mktops-create
  > div
  > div.md-gutter.mktops-stepper
  > div.md-card.main-content.md-theme-default
  > div.header-step
  > div.md-avatar {
  width: 36px;
  height: 36px;
  font-size: 18px;
}

#layout-default
  > div.mkt-main-content
  > div.mktops-create
  > div
  > div.md-gutter.mktops-stepper
  > div.md-card.main-content.md-theme-default
  > div.data-input-step.md-layout
  > div
  > div
  > div
  > div
  > div.title-medium {
  margin-bottom: 4px;
}

#layout-default
  > div.mkt-main-content
  > div.mktops-create
  > div
  > div.md-gutter.mktops-stepper
  > div.md-card.main-content.md-theme-default
  > div.data-input-step.md-layout
  > div
  > div
  > div
  > div {
  margin-top: 10px;
}

#layout-default
  > div.mkt-main-content
  > div.mktops-create
  > div
  > div.md-gutter.mktops-stepper
  > div.md-card.main-content.md-theme-default
  > div.data-input-step.md-layout
  > div
  > div
  > div
  > div
  > div.mktops-select-promotion
  > div {
  width: 380px;
  height: 64px;
}

#layout-default
  > div.mkt-main-content
  > div.mktops-create
  > div
  > div.md-gutter.mktops-stepper
  > div.md-card.main-content.md-theme-default
  > div.data-input-step.md-layout
  > div
  > div
  > div
  > div
  > div.mktops-select-promotion {
  margin-bottom: 20px;
}

#layout-default
  > div.mkt-main-content
  > div.mktops-create
  > div
  > div.md-gutter.mktops-stepper
  > div.md-card.main-content.md-theme-default
  > div.data-input-step.md-layout
  > div
  > div
  > div
  > div
  > div.md-field {
  width: 610px;
  margin-bottom: 3px;
}

#layout-default
  > div.mkt-main-content
  > div.mktops-create
  > div
  > div.md-gutter.mktops-stepper
  > div.md-card.main-content.md-theme-default
  > div.data-input-step.md-layout
  > div
  > div
  > div
  > div
  > div.md-field.pm-code {
  width: 328px;
  margin-bottom: 3px;
}

#layout-default
  > div.mkt-main-content
  > div.mktops-create
  > div
  > div.md-gutter.mktops-stepper
  > div.md-card.main-content.md-theme-default
  > div.data-input-step.md-layout
  > div
  > div
  > div
  > div
  > div:nth-child(6)
  > div:nth-child(2) {
  width: 160px;
}

#layout-default
  > div.mkt-main-content
  > div.mktops-create
  > div
  > div.md-gutter.mktops-stepper
  > div.md-card.main-content.md-theme-default
  > div.data-input-step.md-layout
  > div
  > div
  > div
  > div
  > div:nth-child(6)
  > div:nth-child(1) {
  width: 160px;
}

.md-datepicker-dialog {
  height: 305px;
}

.md-datepicker-body-content {
  height: 262px !important;
}

#layout-default
  > div.mkt-main-content
  > div.mktops-create
  > div
  > div.md-gutter.mktops-stepper
  > div.md-card.main-content.md-theme-default
  > div.data-input-step.md-layout
  > div
  > div
  > div
  > div
  > div.md-layout
  > div
  > div
  > button {
  top: unset;
}

#layout-default
  > div.mkt-main-content
  > div.mktops-create
  > div
  > div.md-gutter.mktops-stepper
  > div.md-card.main-content.md-theme-default
  > div.data-input-step.md-layout
  > div
  > div
  > div
  > div
  > div
  > div
  > div.md-radio.md-theme-default.md-checked
  > div.md-radio-container {
  border-color: #3f51b5;
}

#layout-default
  > div.mkt-main-content
  > div.mktops-create
  > div
  > div.md-gutter.mktops-stepper
  > div.md-card.main-content.md-theme-default
  > div.data-input-step.md-layout
  > div
  > div
  > div
  > div
  > div
  > div
  > div.md-radio.md-theme-default.md-checked
  > div.md-radio-container:after {
  background-color: #3f51b5;
}

#layout-default
  > div.mkt-main-content
  > div.mktops-create
  > div
  > div.md-gutter.mktops-stepper
  > div.md-card.main-content.md-theme-default
  > div.data-input-step.md-layout
  > div
  > div
  > div
  > div
  > div
  > div.div_target {
  width: 80px;
  padding-top: 15px;
}

#layout-default
  > div.mkt-main-content
  > div.mktops-create
  > div
  > div.md-gutter.mktops-stepper
  > div.md-card.main-content.md-theme-default
  > div.data-input-step.md-layout
  > div
  > div
  > div
  > div
  > div
  > div.div_target
  > label.target {
  font-size: 16px;
  font-family: "Roboto";
  color: #727272;
}

#layout-default
  > div.mkt-main-content
  > div.mktops-create
  > div
  > div.md-gutter.mktops-stepper
  > div.md-card.main-content.md-theme-default
  > div.data-input-step.md-layout
  > div
  > div
  > div
  > div
  > div.md-layout.target {
  width: 700px;
}

#layout-default
  > div.mkt-main-content
  > div.mktops-create
  > div
  > div.md-gutter.mktops-stepper
  > div.md-card.main-content.md-theme-default
  > div.data-input-step.md-layout
  > div
  > div
  > div
  > div
  > div.md-layout.target
  > div
  > div
  > label {
  font-size: 16px;
  font-family: "Roboto";
  color: #727272;
  padding-left: 10px;
}

#layout-default
  > div.mkt-main-content
  > div.mktops-create
  > div
  > div.md-gutter.mktops-stepper
  > div.md-card.main-content.md-theme-default
  > div.data-input-step.md-layout
  > div
  > div
  > div
  > div
  > div.md-layout.target
  > div:nth-child(4)
  > div
  > label
  > div {
  width: 130px;
  margin-left: 115px;
  top: -53px;
  position: relative;
}

#layout-default
  > div.mkt-main-content
  > div.mktops-create
  > div
  > div.md-gutter.mktops-stepper
  > div.md-card.main-content.md-theme-default
  > div.data-input-step.md-layout
  > div
  > div
  > div
  > div
  > div.md-layout.target
  > div:nth-child(3)
  > div
  > label
  > div.md-field {
  width: 110px;
  margin-left: 55px;
  top: -53px;
  position: relative;
}

#layout-default
  > div.mkt-main-content
  > div.mktops-create
  > div
  > div.md-gutter.mktops-stepper
  > div.md-card.main-content.md-theme-default
  > div.md-card-actions.mktops-action-button.md-alignment-right {
  padding-top: 0px;
}

#layout-default
  > div.mkt-main-content
  > div.mktops-create
  > div
  > div.md-gutter.mktops-stepper
  > div.md-card.main-content.md-theme-default
  > div.data-input-step.md-layout
  > div
  > div
  > div
  > div
  > div.md-invalid
  > span.md-error {
  top: 0px;
  margin-left: 100px;
  bottom: unset;
}

#layout-default
  > div.mkt-main-content
  > div.mktops-create
  > div
  > div.md-gutter.mktops-stepper
  > div.md-card.main-content.md-theme-default
  > div.data-input-step.md-layout
  > div
  > div
  > div
  > div
  > div.md-invalid
  > label:not(:focus) {
  animation: unset;
}

#layout-default
  > div.mkt-main-content
  > div.mktops-create
  > div
  > div.md-gutter.mktops-stepper
  > div.md-card.main-content.md-theme-default
  > div.data-input-step.md-layout
  > div
  > div
  > div
  > div
  > div.md-invalid
  > span.md-error {
  transition: unset;
}

#layout-default
  > div.mkt-main-content
  > div.mktops-create
  > div
  > div.md-gutter.mktops-stepper
  > div.md-card.main-content.md-theme-default
  > div.data-input-step.md-layout
  > div
  > div
  > div
  > div
  > div.md-field
  > span.md-error {
  transition: unset;
}

body
  > div.md-datepicker-dialog.md-theme-default
  :not(input):not(textarea)::-moz-selection {
  /* Code for Firefox */
  background-color: #3e51b5;
}

body
  > div.md-datepicker-dialog.md-theme-default
  :not(input):not(textarea)::selection {
  background-color: #3e51b5;
}

/* .md-field.md-theme-default.md-disabled .md-input {
    -webkit-text-fill-color: #bcbdbc !important;
}
.md-field.md-theme-default.md-disabled:after {
    background-color: #bcbdbc;
    background-image: linear-gradient(to right, #bcbdbc 0%, #bcbdbc 33%, transparent 0%) !important;
}
.md-field.md-theme-default.md-disabled:before {
    background-color: #bcbdbc;
}
.-disabled {
    color: #bcbdbc;
} */
</style>

<style lang="scss">
.md-has-value.md-datepicker .md-input {
  width: inherit;
  padding-right: 10px !important;
}

.maincontent-create-1 {
  .box-promotion-repeat {
    margin: 10px 0px 30px 0px;
    padding: 5px;
    box-shadow: 0 0 3px rgba(0, 0, 0, 0.16);
    display: block;

    .row-bg-gray:hover {
      background: rgba(236, 236, 235, 1);
      border-radius: 4px;
    }

    .nowrap-title {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    > div > div {
      padding: 0px 5px;
    }

    .tab-chip {
      padding-left: 10px;
      padding-right: 8px;
      border-radius: 35px;
      color: white;
      font-size: 12px;
      padding-top: 5px;
      padding-bottom: 5px;
      display: flex;
      background-color: #3f7fb5;
      margin: 2px;

      &.-delete {
        background-color: #1c64a0;
        padding-left: 5px;
        padding-right: 4px;
        padding-top: 3px;
        padding-bottom: 2px;
        margin-left: 3px;
        display: inline;
        cursor: pointer;

        .material-icons {
          font-size: 11px;
        }
      }
    }
  }

  .content-step-data {
    .selected-promotion-strategy {
      width: 20%;
      margin-top: 3px;
      padding: 5px 0 25px;

      .multiselect {
        font-weight: 300;

        &.next-error {
          border: 1px solid #ff1744;
          border-radius: 5px;
        }

        .z-index-top {
          z-index: 10;
        }

        margin: 5px 0px;

        .multiselect__single,
        .multiselect__input {
          font-size: 14px;

          div {
            display: flex;
            width: 100%;

            .-delete {
              width: 5%;
              margin: 0px 5px;

              .material-icons {
                font-size: 18px;
                margin-top: 1px;
                cursor: pointer;
                color: gray;
              }
            }
          }
        }

        .multiselect__tags {
          padding: 7px 30px 0 8px;

          input {
            font-family: lato;
            font-weight: 300;
          }

          .multiselect__placeholder {
            margin: 0px;
          }

          ::placeholder {
            color: #bdbdbd;
            opacity: 1;
          }
        }

        .multiselect__content-wrapper {
          font-size: 14px;
          z-index: 10;
          font-family: kanit;
        }

        .multiselect__option {
          min-height: 34px;
          padding: 12px 12px 0px 12px;
        }

        ::-webkit-scrollbar {
          width: 8px;
          height: 8px;
        }
      }
    }

    .floating-data-title {
      width: 400px;
      position: fixed;
      // top: 50px;
      // left: 50px;
      // background-color: #fff;
      left: 25.6%;
      background-color: #b3b3b3;
      border: 1px solid #ccc;
      padding: 10px;
      box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
      z-index: 999;
      margin-top: 58px;
      color: white;

      &::before {
        content: '';
        position: absolute;
        top: -10px; /* ปรับตำแหน่งบนของสามเหลี่ยม */
        left: 50%; /* จากตรงกลางของ .floating-data-title */
        margin-left: -5px; /* ปรับตำแหน่งแนวนอนของสามเหลี่ยม */
        border-width: 0 10px 10px;
        border-style: solid;
        border-color: transparent transparent #b3b3b3;
      }
    }
  }
}

.dialog-promotion-repeat {
  &.md-dialog {
    max-height: unset;
  }

  width: 70%;
  max-width: 70% !important;
  height: 80%;
  z-index: 6;
  transform: unset !important;
  top: 9% !important;
  left: 15% !important;

  .md-dialog-title.md-title {
    font-size: 18px;
    margin-bottom: 5px;
    padding: 24px 25px 0;
  }

  .layout-dialog {
    padding: 10px 25px 5px 25px;
    font-family: kanit;
    color: #727272;

    ::placeholder {
      color: #bdbdbd;
      opacity: 1;
      font-size: 14px;
      font-family: lato;
    }
  }

  .-action {
    padding: 8px 20px 10px 24px;
    bottom: 0px;
    margin-right: auto;
    margin-left: auto;
    width: 100%;
    justify-content: flex-end;
    position: absolute;

    .-cancel .md-button-content {
      color: #727272;
    }

    .-save {
      color: #3f51b5 !important;

      &.-disabled {
        color: #b6b6b6 !important;
      }
    }

    .-red {
      color: #f44336 !important;
    }

    .-green {
      color: #64a064 !important;
    }
  }

  .md-search-box {
    margin: 10px 0px 0px 0px;
    padding-top: unset;
    width: 40%;
    border-radius: 3px;
    min-height: 36px;
    box-shadow: 0 0 3px rgba(0, 0, 0, 0.16), 0 0 0 rgba(0, 0, 0, 0),
      0 1px 1px -2px rgba(0, 0, 0, 0);

    .md-icon.material-icons {
      margin-left: 10px;
      margin-top: 7px;
      color: rgba(0, 0, 0, 0.54);
    }

    .md-input {
      height: 36px;
      margin-left: 7px;
    }

    &.md-field.md-theme-default.md-focused > .md-icon {
      color: rgba(0, 0, 0, 0.54) !important;
    }

    &.md-field > .md-icon:after,
    &.md-field:after,
    &.md-field:before {
      content: none;
    }
  }

  // .multiselect {
  //     font-weight: 300;

  //     .z-index-top {
  //         z-index: 10;
  //     }

  //     margin: 5px 0px;

  //     .multiselect__single,
  //     .multiselect__input {
  //         font-size: 14px;

  //         div {
  //             display: flex;
  //             width: 100%;

  //             .-delete {
  //                 width: 5%;
  //                 margin: 0px 5px;

  //                 .material-icons {
  //                     font-size: 18px;
  //                     margin-top: 1px;
  //                     cursor: pointer;
  //                     color: gray;
  //                 }
  //             }
  //         }
  //     }

  //     .multiselect__tags {
  //         padding: 8px 30px 0 8px;

  //         input {
  //             font-family: lato;
  //             font-weight: 300;
  //         }

  //         .multiselect__placeholder {
  //             margin: 0px;
  //         }

  //         ::placeholder {
  //             color: #BDBDBD;
  //             opacity: 1;
  //         }
  //     }

  //     .multiselect__content-wrapper {
  //         font-size: 14px;
  //         z-index: 10;
  //     }

  //     .multiselect__option {
  //         min-height: 34px;
  //         padding: 12px 12px 0px 12px;
  //     }

  //     ::-webkit-scrollbar {
  //         width: 8px;
  //         height: 8px;
  //     }
  // }

  #table-promotion-repeat {
    display: grid;

    #divHeadList {
      width: 99.4%;
      display: -webkit-inline-box;
      font-size: 13px;
      font-weight: bold;
      margin-top: 10px;
      margin-bottom: 10px;

      div {
        // border: 1px solid pink;
        padding-left: 5px;
        padding-right: 5px;
        // color: #414141;

        &.-text-right {
          text-align: right;
        }

        &.-text-center {
          text-align: center;
        }
      }
    }

    #divBodyList {
      width: 100%;
      height: calc(80vmin - 225px);
      display: block;
      overflow-y: scroll;
      // font-size: 13px;
      // font-weight: 300;

      > div {
        width: 100%;
        height: 40px;
        display: -webkit-inline-box;
        padding-top: 5px;
        padding-bottom: 5px;

        div {
          // border: 1px solid pink;
          padding-left: 5px;
          padding-right: 5px;
          // color: #414141;

          &.-text-right {
            text-align: right;
          }

          &.-text-center {
            text-align: center;
          }

          &.nowrap-title {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          &.-font-kanit {
            font-size: 14px;
            font-family: kanit;
          }
        }
      }

      .mktops-subheader-filter {
        height: 32px;

        .md-field.box > .md-input.md-select-value,
        .md-field.box > .md-menu.md-select {
          font-size: 14px;
          width: 115.72px;
          height: 32px;
        }

        .md-field.md-field.box {
          margin-top: unset;
          margin-bottom: unset;
          padding: unset;
          min-height: 32px;
        }

        .md-field:after,
        .md-field:before {
          left: unset;
        }

        .md-field.box .md-input.md-input.md-select-value,
        .md-field.box label {
          font-size: 14px;
          padding-left: 12px;
          padding-top: 3px;
          color: #727272;
        }

        .md-field.box .md-select {
          background-color: #efefef;
          border-radius: 3px;
        }
      }

      &::-webkit-scrollbar {
        height: 7px;
        width: 5px;
      }
    }
  }
}
</style>
